module.exports = __webpack_public_path__ + "static/media/zm.2b5f9a1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/zm.svg
// module id = 294
// module chunks = 0